import type { Rule } from "ant-design-vue/es/form";

/**
 * 常用正则
 */
const patterns = {
	phone: /^1[3-9]\d{9}$/, // 中国大陆手机号
	email: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
	idCard: /(^\d{15}$)|(^\d{17}([0-9Xx])$)/, // 简单身份证校验
	password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{6,20}$/, // 6-20位，至少包含字母和数字
	/**
	 * 编码类型（禁止中文和特殊符号）
	 */
	code: /^[A-Za-z0-9_-]+$/,
};

/**
 * 通用表单验证方法
 */
export const validators = {
	required: (message = "该字段不能为空"): Rule => ({
		required: true,
		message,
		trigger: "blur",
	}),

	phone: (message = "请输入正确的手机号"): Rule => ({
		pattern: patterns.phone,
		message,
		trigger: "blur",
	}),

	email: (message = "请输入正确的邮箱地址"): Rule => ({
		pattern: patterns.email,
		message,
		trigger: ["blur", "change"],
	}),

	idCard: (message = "请输入正确的身份证号码"): Rule => ({
		pattern: patterns.idCard,
		message,
		trigger: "blur",
	}),

	password: (message = "密码需包含字母和数字，长度6-20位"): Rule => ({
		pattern: patterns.password,
		message,
		trigger: "blur",
	}),

	min: (min: number, message?: string): Rule => ({
		min,
		message: message || `至少输入 ${min} 个字符`,
		trigger: "blur",
	}),

	max: (max: number, message?: string): Rule => ({
		max,
		message: message || `最多输入 ${max} 个字符`,
		trigger: "blur",
	}),

	length: (len: number, message?: string): Rule => ({
		len,
		message: message || `请输入 ${len} 个字符`,
		trigger: "blur",
	}),

	code: (message = "只能包含字母、数字、下划线或连字符"): Rule => ({
		pattern: patterns.code,
		message,
		trigger: "blur",
	}),

	/**
	 * 自定义函数校验
	 */
	custom: (validator: Rule["validator"], trigger: Rule["trigger"] = "blur"): Rule => ({
		validator,
		trigger,
	}),
};
